/******************************************************************
 * Archivo : client/src/components/Header/DynamicMenu/index.js
 * Proyecto: CB30
 * Módulo  : Menú dinámico
 *
 * Propósito:
 * Construir la navegación principal a partir de los permisos
 * asignados al único rol del usuario autenticado.
 *
 * Reglas:
 * - Los módulos se obtienen dinámicamente desde los permisos.
 * - Los permisos _VER determinan las opciones de navegación.
 * - En REPORTES también se consideran permisos _EXPORTAR.
 * - Las funcionalidades se muestran dentro de su módulo.
 * - Los permisos de CREAR, EDITAR, ELIMINAR, etc. se utilizan
 *   dentro de las pantallas correspondientes.
 ******************************************************************/

import React from "react";
import { Link } from "react-router-dom";

const DynamicMenu = ({ user }) => {
  if (!user || !user.roles || user.roles.length === 0) {
    return null;
  }

  const role = user.roles[0];

  console.log("ROL MENU:", role.code);
  console.log("PERMISOS MENU:", role.permissions);

  if (!role || !role.permissions) {
    return null;
  }

  const permissions = role.permissions.filter(
    permission =>
      permission &&
      permission.active !== false
  );

  // Permisos que participan en la navegación.
  const navigationPermissions = permissions.filter(
    permission => {
      if (!permission.code) {
        return false;
      }

      // Navegación normal mediante permisos _VER.
      if (permission.code.endsWith("_VER")) {
        return true;
      }

      // Las exportaciones de Reportes también son opciones
      // independientes del menú.
      if (
        permission.module === "REPORTES" &&
        permission.code.endsWith("_EXPORTAR")
      ) {
        return true;
      }

      return false;
    }
  );

  // Agrupar: MÓDULO -> FUNCTIONALITY -> PERMISOS
  const modules = {};

  navigationPermissions.forEach(permission => {
    if (!permission.module || !permission.functionality) {
      return;
    }

    if (!modules[permission.module]) {
      modules[permission.module] = {};
    }

    if (!modules[permission.module][permission.functionality]) {
      modules[permission.module][permission.functionality] = [];
    }

    modules[permission.module][permission.functionality].push(
      permission
    );
  });

  // Perfil: opción fija dentro de Gestión.
if (!modules.GESTION) {
  modules.GESTION = {};
}

modules.GESTION.PERFIL = [
  {
    label: "PERFIL"
  }
];

  // Nombre visible del módulo.
  const formatModuleLabel = value => {
    if (!value) {
      return "";
    }

    const labels = {
      GESTION: "Gestión",
      MEDICION: "Medición",
      REPORTES: "Reportes"
    };

    return (
      labels[value] ||
      value.charAt(0) +
        value.slice(1).toLowerCase()
    );
  };

  // Rutas de las funcionalidades existentes.
  const routes = {
    USUARIOS: "/admin/usuarios",
    ROLES: "/admin/roles",
    PERFIL: `/dashboard/perfil/editar/${user.id}`,
    ENCUESTAS: "/admin/encuestas",
    REPORTES: "/admin/reportes",
    RESULTADO_USUARIO: "/admin/visor",

    // Punto de entrada de Reportes.
    RESULTADO_ENCUESTA: "/admin/reportes",
    EXPORTACION_CSV_ENCUESTA: "/admin/reportes"
  };

  return (
    <React.Fragment>
      {Object.keys(modules).map(moduleName => {
        const functionalities = modules[moduleName];

        return (
          <li
            className="nav-item dropdown"
            key={moduleName}
          >
            <a
              className="nav-link dropdown-toggle text-white"
              href="#!"
              id={`menu-${moduleName}`}
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              {formatModuleLabel(moduleName)}
            </a>

            <div
              className="dropdown-menu"
              aria-labelledby={`menu-${moduleName}`}
            >
              {Object.keys(functionalities).map(
                functionality => {

                  const permission =
                    functionalities[functionality][0];

                  if (!permission) {
                    return null;
                  }


                  const route = routes[functionality];

                  if (!route) {
                    return null;
                  }

                  return (
                    <Link
                      key={functionality}
                      to={route}
                      className="dropdown-item"
                    >
                      {permission.label ||
                        functionality}
                    </Link>
                  );
                }
              )}
            </div>
          </li>
        );
      })}
    </React.Fragment>
  );
};

export default DynamicMenu;


// WEBPACK FOOTER //
// ./src/components/Header/DynamicMenu/index.js